module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-select', {
    attrs: {
      "placeholder": "Select"
    },
    on: {
      "change": _vm.updated
    },
    model: {
      value: (_vm.formData),
      callback: function($$v) {
        _vm.formData = $$v
      },
      expression: "formData"
    }
  }, _vm._l((_vm.selectData), function(group) {
    return _c('el-option-group', {
      key: group.label,
      attrs: {
        "label": group.label
      }
    }, _vm._l((group.options), function(item) {
      return _c('el-option', {
        key: item.value,
        attrs: {
          "label": item.label,
          "value": item.value
        }
      })
    }), 1)
  }), 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3fc52962"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/atoms/forms/SelectDataType.vue
// module id = 1443
// module chunks = 0